import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Box, Flex, Button } from "rebass";
import { Banner, NavGrid, Container, Grid, LogoGrid } from "..";
import Logo from "../components/Logo";
import { Link } from 'gatsby';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Banner mdxType="Banner">
      <Box mt='auto' mdxType="Box" />
      <LogoGrid mdxType="LogoGrid">
        <Logo text='' size={192} mdxType="Logo" />
        <div>
          <h1 {...{
            "id": "reforml"
          }}>{`Reforml`}</h1>
          <h2 {...{
            "id": "simple-yet-flexible-react-form-defined-by-yaml"
          }}>{`Simple yet flexible react form defined by yaml`}</h2>
          <Flex alignItems='baseline' sx={{
            flexWrap: 'wrap'
          }} mdxType="Flex">
            <Box mr={4} mb={3} mdxType="Box">
              <Button as={Link} to='/getting-started' mdxType="Button">Getting Started</Button>
            </Box>
            <Box sx={{
              w: '100%',
              pre: {
                w: '100%'
              }
            }} mb={3} mdxType="Box">
              <pre><code parentName="pre" {...{
                  "className": "language-sh"
                }}>{`npm i reforml
`}</code></pre>
            </Box>
            <Box mdxType="Box" />
          </Flex>
        </div>
      </LogoGrid>
      <Box my='auto' sx={{
        minHeight: '16px'
      }} mdxType="Box" />
      <Box mdxType="Box">
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "live=true",
            "live": "true"
          }}>{`() => {
  const [value, setValue] = useState({})
  const fields = useMemo(() => jsyaml.load(\`
  myField:
    type: text
    label: my first reforml field
  \`), [])
  return (
    <div>
      <BaseForm fields={fields} value={value} onChange={setValue}/>
      {value.myField}
    </div>
  )
}
`}</code></pre>
      </Box>
    </Banner>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      